export default [
    {
        path: '/',
        redirect: to => {
            const newPath = to.fullPath
                .replace('/#', '')
                .replace('#/', '')
                .replace('#', '');

            if (newPath !== '/') {
                return newPath;
            }

            return { name: 'auth.login' };
        },
    },
];
